module.exports = __webpack_public_path__ + "img/14.b55d08b7.jpg";